const formatUrl = (urlToFormat): string => {
  const toReplace = `${urlToFormat}`
    .replace('http://', '')
    .replace('https://', '');

  let url = `${urlToFormat}`;

  if (toReplace.includes('//')) {
    url = url.replace(toReplace, toReplace.replace('//', '/'));
  }
  return url;
};

export default formatUrl;
